import React from "react";
import Nav from "./Nav";
import Footer from "./Footer";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-100 ">
        <div className='p-6 '>
        <Nav/>
        </div>
       
      {/* Container */}
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg my-24 p-6">
        {/* Heading */}
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">
        Terms and Conditions
        </h1>

        {/* Content */}
        <div className="space-y-6 text-gray-700">
          <p>
          Welcome to <span className="font-semibold">Pravasa.in</span>, These terms and conditions outline the rules and regulations for the use of our travel services.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
            1. Booking and Payments
            </h2>
            <p>
            All bookings are subject to availability and confirmation. Full payment is required at the time of booking unless otherwise stated.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
            2. Cancellations and Refunds
            </h2>
            <p>
            Cancellations must be made at least 48 hours in advance. Refund policies vary depending on the service provider and are subject to change.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
            3. Travel Documentation
            </h2>
            <p>
            Travelers are responsible for ensuring they have valid passports, visas, and other required documents.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
            4. Liability
            </h2>
            <p>
            Pravasa.in is not responsible for any loss, damage, injury, or delay caused by third-party service providers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
            5. Changes to Terms
            </h2>
            <p>
            We reserve the right to modify these terms at any time. Users will be notified of significant changes via email or website announcements.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              6. Changes to This Policy
            </h2>
            <p>
            If you have any questions about our terms, please contact us at support@pravasa.in.
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center text-gray-600">
          <p>
            &copy; {new Date().getFullYear()} Pravasa.in. All rights reserved.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default TermsAndConditions;
